import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { InsuranceRibbon } from '../components/InsuranceRibbon';
import { Financing } from '../components/Financing';
import { Services } from '../components/Services';
import { Doctors } from '../components/Doctors';
import { Testimonials } from '../components/Testimonials';
import { Footer } from '../components/Footer';
import { useScreenInit } from '../useScreenInit';
export function LandingPage() {
  useScreenInit();
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  }, []);
  return <div className="min-h-screen bg-white selection:bg-teal-100 selection:text-teal-900" data-id="element-238">
      <Header data-id="element-239" />
      <main data-id="element-240">
        <Hero data-id="element-241" />
        <InsuranceRibbon data-id="element-242" />
        <Financing data-id="element-243" />
        <Services data-id="element-244" />
        <Doctors data-id="element-245" />
        <Testimonials data-id="element-246" />
      </main>
      <Footer data-id="element-247" />
    </div>;
}